import React, { useEffect } from 'react'
import axiosInstance from '../axios'
import { useHistory } from 'react-router-dom'

export default function LoadingAndRefreshingToken() {
  const history = useHistory()

  useEffect(() => {
    const refresh = async () => {
      try {
        // PUT /api/v1/session → devolve novo access e refresh
        const response = await axiosInstance.put(
          `${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/session`
        )

        const newAccessToken = response.data?.payload?.access

        if (newAccessToken) {
          localStorage.setItem('access-token', newAccessToken)
        }

        // volta para a página atual
        history.go(0)
      } catch (error) {
        console.error("Erro ao atualizar token:", error)
        localStorage.removeItem('access-token')
        history.push('/login')
      }
    }

    refresh()
  }, [history])

  return <div>Convalida sessione...</div>
}
